// extracted by mini-css-extract-plugin
export default {"container":"NoteControls_container__Ywd3N","containerWithBackground":"NoteControls_containerWithBackground__f3yX1"};